'use client';
import { LiveChatWidget, WidgetConfig } from '@livechat/widget-react';

const license = '12092754';

type LiveChatProps = Omit<WidgetConfig, 'license'>;

function LiveChat(props: LiveChatProps) {
  return (
    <LiveChatWidget {...props} license={license} onReady={props.onReady} />
  );
}

export default LiveChat;
